var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList,attrs:{"data-id":_vm._uid},on:{"click":_vm.toggle}},[(_vm.icon)?_c('div',{staticClass:"a-label__icon"},[_vm._t("icon")],2):_vm._e(),_c('div',{staticClass:"a-label__text"},[_vm._t("text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }